import { filter } from '@atlaskit/adf-utils/filter';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { FieldId } from '../../types/form/form-fields';
import type { FormSection } from '../../types/form/form-section';

export const getFieldIdsUnderSection = (section: FormSection): FieldId[] =>
	(section.layout.content ?? []).flatMap((contentNode) =>
		filter(contentNode, (node: ADFEntity) => {
			if (!node.attrs || !node.attrs.parameters) {
				return false;
			}

			const { id } = node.attrs.parameters;
			if (!((typeof id === 'string' && id.length > 0) || typeof id === 'number')) {
				return false;
			}

			return node.attrs.extensionKey === 'question';
		}).flatMap((node: ADFEntity) => (node.attrs ? [String(node.attrs.parameters.id)] : [])),
	);
